import {
  SET_ALL_PARENT_CHILD_OPTIONS,
  SET_ALL_SUPPORTED_INTEGRATIONS,
  SET_CUBOH_MENU_ITEMS,
  SET_IS_LOADING,
  SET_INTEGRATIONS_ERROR,
  SET_INTEGRATIONS_IS_LOADING,
  SET_ERROR,
  SET_MERCHANT_INTEGRATIONS,
  SET_PARENT_CHILD_ERROR,
  SET_PARENT_CHILD_IS_LOADING,
  SET_POS_MENUS,
  SET_SINGLE_MENU,
  SET_SUPPORTED_IS_LOADING,
  SET_SUPPORTED_ERROR,
  SET_AVAILABLE_CLASSIFICATIONS,
  SET_CLASSIFICATIONS_IS_LOADING,
  SET_CLASSIFICATIONS_ERROR,
  UPDATE_CUBOH_MENU_ITEM,
  SET_DEFAULT_STATE,
  UPDATE_MENU_INTEGRATION,
} from 'constants/menuManagement';

export const setSingleMenu = ({ normalizedData, itemType, group }) => ({
  type: SET_SINGLE_MENU,
  itemType,
  data: normalizedData,
  group,
});

export const setCubohMenuItems = ({ normalizedData, itemType, group }) => ({
  type: SET_CUBOH_MENU_ITEMS,
  itemType,
  data: normalizedData,
  group,
});

export const updateCubohMenuItem = ({ group, id, data }) => ({
  type: UPDATE_CUBOH_MENU_ITEM,
  group,
  id,
  data,
});

export const updateCubohMenuIntegration = ({ id, data }) => ({
  type: UPDATE_MENU_INTEGRATION,
  id,
  data,
});

export const setPOSMenus = menus => ({
  type: SET_POS_MENUS,
  menus,
});

export const setIsLoading = ({ parentGroup, group, isLoading }) => ({
  type: SET_IS_LOADING,
  parentGroup,
  group,
  isLoading,
});

export const setError = ({ parentGroup, group, hasError, message }) => ({
  type: SET_ERROR,
  parentGroup,
  group,
  hasError,
  message,
});

export const setDefaultState = () => ({
  type: SET_DEFAULT_STATE,
});

export const setAllParentChildOptions = ({ menuId, allParentChildOptions }) => ({
  type: SET_ALL_PARENT_CHILD_OPTIONS,
  menuId,
  allParentChildOptions,
});

export const setParentChildIsLoading = ({ menuId, isLoading }) => ({
  type: SET_PARENT_CHILD_IS_LOADING,
  menuId,
  isLoading,
});

export const setParentChildError = ({ menuId, hasError, error }) => ({
  type: SET_PARENT_CHILD_ERROR,
  menuId,
  hasError,
  error,
});

export const setMerchantIntegrations = ({ merchantId, merchantIntegrations }) => ({
  type: SET_MERCHANT_INTEGRATIONS,
  merchantId,
  merchantIntegrations,
});

export const setMerchantIntegrationsLoading = ({ merchantId, isLoading }) => ({
  type: SET_INTEGRATIONS_IS_LOADING,
  merchantId,
  isLoading,
});

export const setMerchantIntegrationsError = ({ merchantId, hasError, error }) => ({
  type: SET_INTEGRATIONS_ERROR,
  merchantId,
  hasError,
  error,
});

export const setSupportedIntegrations = ({ supportedIntegrations }) => ({
  type: SET_ALL_SUPPORTED_INTEGRATIONS,
  supportedIntegrations,
});

export const setSupportedIntegrationsLoading = ({ isLoading }) => ({
  type: SET_SUPPORTED_IS_LOADING,
  isLoading,
});

export const setSupportedIntegrationsError = ({ hasError, error }) => ({
  type: SET_SUPPORTED_ERROR,
  hasError,
  error,
});

export const setAvailableClassifications = ({ availableClassifications }) => ({
  type: SET_AVAILABLE_CLASSIFICATIONS,
  availableClassifications,
});

export const setClassificationsLoading = ({ isLoading }) => ({
  type: SET_CLASSIFICATIONS_IS_LOADING,
  isLoading,
});

export const setClassificationsError = ({ hasError, error }) => ({
  type: SET_CLASSIFICATIONS_ERROR,
  hasError,
  error,
});
